module.exports = __webpack_public_path__ + "static/fonts/SaoChingcha-Regular.4cca901.woff2";